interface Environment {
  base_url: string;
  media_base_url?: string;
  token?: string;
  token_prefix?: string;
  base_name?: string;
  debugSetting?: boolean;
  desktop_app?: boolean;
  masters?: boolean;
  form_validation?: boolean;
  logger?: boolean;
  company_title: string;
  additional_info: string;
}
const env: Record<string, Environment> = {};

env["local"] = {
  base_url: "http://192.168.0.200:8000/api",
  token_prefix: "Token",
  base_name: "",
  debugSetting: true,
  masters: true,
  form_validation: false,
  logger: false,
  company_title: "ABC SHIP MANAGEMENT",
  additional_info: "none",
};

env["dev"] = {
  base_url: "https://dev.ecosail.app/v1/api",
  media_base_url: "https://dev.ecosail.app/v1",
  token_prefix: "Token",
  base_name: "",
  debugSetting: true,
  masters: true,
  desktop_app: false,
  form_validation: false,
  logger: false,
  company_title: "ABC SHIP MANAGEMENT",
  additional_info: "none",
};

env["demo"] = {
  base_url: "https://demo.ecosail.app/v1/api",
  media_base_url: "https://demo.ecosail.app/v1",
  token_prefix: "Token",
  base_name: "",
  debugSetting: false,
  desktop_app: false,
  masters: false,
  form_validation: false,
  logger: false,
  company_title: "ABC SHIP MANAGEMENT",
  additional_info: "none",
};

env["lfonds"] = {
  base_url: "https://lfonds.ecosail.app/v1/api",
  media_base_url: "https://lfonds.ecosail.app/v1",
  token_prefix: "Token",
  base_name: "",
  debugSetting: false,
  masters: false,
  desktop_app: false,
  form_validation: false,
  logger: false,
  company_title: "LFONDS SHIP MANAGEMENT",
  additional_info: "lfonds",
};

env["proactive"] = {
  base_url: "https://proactive.ecosail.app/v1/api",
  media_base_url: "https://proactive.ecosail.app/v1",
  token_prefix: "Token",
  base_name: "",
  debugSetting: false,
  masters: false,
  desktop_app: false,
  form_validation: false,
  logger: false,
  company_title: "PROACTIVE SHIP MANAGEMENT",
  additional_info: "none",
};

export default env["proactive"];
